// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   DialogTitle,
//   TextField,
//   IconButton,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Checkbox,
//   Switch,
// } from "@mui/material";
// import { Edit, Delete } from "@mui/icons-material";
// import TableComponent from "../../Components/TableComponent/TableComponent";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { API_BASE_URL } from "../../config";
// import api from "../../api/axiosInterceptor";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";

// export const AdminNewsComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedNews, setSelectedNews] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: "",
//     link: "",
//     date_of_issue: "",
//     date_of_expiry: "",
//     is_active: true,
//   });

//   const [linkType, setLinkType] = useState("url");
//   const [file, setFile] = useState(null);

//   const [formErrors, setFormErrors] = useState({});
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteNews, setDeleteNews] = useState(null);

//   // NEW: Control for showing all news vs filtered news
//   const [showAllNews, setShowAllNews] = useState(false);

//   const location = useLocation();
//   const navigate = useNavigate();

//   // Update showAllNews from query param on mount and location change
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const all = params.get("all");
//     setShowAllNews(all === "true");
//   }, [location.search]);

//   // Fetch news with optional query param based on showAllNews
//   const fetchNews = () => {
//     setLoading(true);
//     const url = `${API_BASE_URL}/home-notification/news/`;
//     const params = showAllNews ? { all: "true" } : {};
//     axios
//       .get(url, { params })
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           viewDetails: item.link,
//           date_of_issue: item.date_of_issue,
//           date_of_expiry: item.date_of_expiry,
//           is_active: item.is_active,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSnackbarMessage("Failed to load news.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     // Whenever showAllNews changes, update the URL query param and fetch data
//     const params = new URLSearchParams(location.search);
//     if (showAllNews) {
//       params.set("all", "true");
//     } else {
//       params.delete("all");
//     }
//     // Update URL without reload
//     navigate({ search: params.toString() }, { replace: true });
//     fetchNews();
//   }, [showAllNews]); // eslint-disable-line react-hooks/exhaustive-deps

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddNews = () => {
//     setIsEditMode(false);
//     setFormData({
//       subject: "",
//       link: "",
//       date_of_issue: "",
//       date_of_expiry: "",
//       is_active: true,
//     });
//     setLinkType("url");
//     setFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (news) => {
//     setIsEditMode(true);
//     setSelectedNews(news);
//     setFormData({
//       subject: news.subject || "",
//       link: news.viewDetails || "",
//       date_of_issue: news.date_of_issue || "",
//       date_of_expiry: news.date_of_expiry || "",
//       is_active: news.is_active ?? true,
//     });
//     setLinkType("url");
//     setFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (news) => {
//     setDeleteNews(news);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/news/${deleteNews.id}/`)
//       .then(() => {
//         setSnackbarMessage("News deleted successfully.");
//         setSnackbarSeverity("success");
//         setSnackbarOpen(true);
//         fetchNews();
//       })
//       .catch(() => {
//         setSnackbarMessage("Failed to delete news.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteNews(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = "Subject is required";
//     if (!formData.date_of_issue) errors.date_of_issue = "Issue date is required";
//     if (!formData.date_of_expiry) errors.date_of_expiry = "Expiry date is required";
//     if (formData.date_of_issue && formData.date_of_expiry) {
//       if (new Date(formData.date_of_expiry) < new Date(formData.date_of_issue))
//         errors.date_of_expiry = "Expiry date cannot be before issue date";
//     }

//     if (linkType === "url") {
//       if (!formData.link?.trim()) errors.link = "Link is required";
//       else if (!/^https?:\/\/.+\..+/.test(formData.link)) errors.link = "Invalid link format";
//     } else {
//       if (!file) errors.link = "File is required";
//     }
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const formDataToSend = new FormData();
//     formDataToSend.append("subject", formData.subject);
//     formDataToSend.append("date_of_issue", formData.date_of_issue);
//     formDataToSend.append("date_of_expiry", formData.date_of_expiry);
//     formDataToSend.append("is_active", formData.is_active);

//     if (linkType === "url") {
//       formDataToSend.append("link", formData.link);
//     } else if (file) {
//       formDataToSend.append("link", file);
//     }

//     const url = isEditMode
//       ? `${API_BASE_URL}/home-notification/news/${selectedNews.id}/`
//       : `${API_BASE_URL}/home-notification/news/`;
//     const method = isEditMode ? "patch" : "post";

//     try {
//       await api[method](url, formDataToSend, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       setSnackbarMessage(isEditMode ? "News updated successfully." : "News added successfully.");
//       setSnackbarSeverity("success");
//       setSnackbarOpen(true);
//       fetchNews();
//     } catch {
//       setSnackbarMessage(isEditMode ? "Failed to update news." : "Failed to add news.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//     } finally {
//       setOpenFormDialog(false);
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "subject", field: "subject", headerName: "Subject", width: 250 },
//     { id: "date_of_issue", field: "date_of_issue", headerName: "Issue Date", width: 130 },
//     { id: "date_of_expiry", field: "date_of_expiry", headerName: "Expiry Date", width: 130 },
//     {
//       id: "is_active",
//       field: "is_active",
//       headerName: "Active",
//       width: 80,
//       renderCell: (params) => (params.value ? "Yes" : "No"),
//     },
//     {
//       id: "viewDetails",
//       field: "viewDetails",
//       headerName: "View Details",
//       width: 140,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           View Details
//         </a>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         bgcolor="rgba(195,234,203,0.1)"
//         p={2}
//       >
//         <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
//           News
//         </Typography>

//         <Box display="flex" alignItems="center" gap={2}>
//           <Typography>Show All News</Typography>
//           <Switch
//             checked={showAllNews}
//             onChange={() => setShowAllNews(!showAllNews)}
//             inputProps={{ "aria-label": "show all news toggle" }}
//           />
//           <Button variant="contained" color="primary" onClick={handleAddNews}>
//             Add News
//           </Button>
//         </Box>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{ "& .MuiDataGrid-columnHeaders": { backgroundColor: "#1976d2", color: "#fff", fontWeight: "bold" } }}
//       />

//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? "Edit News" : "Add News"}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             fullWidth
//             label="Subject"
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//           />

//           <Box mt={2}>
//             <FormControl component="fieldset">
//               <FormLabel component="legend">Link Type</FormLabel>
//               <RadioGroup
//                 row
//                 value={linkType}
//                 onChange={(e) => {
//                   setLinkType(e.target.value);
//                   setFormData({ ...formData, link: "" });
//                   setFile(null);
//                   setFormErrors({ ...formErrors, link: undefined });
//                 }}
//               >
//                 <FormControlLabel value="url" control={<Radio />} label="URL" />
//                 <FormControlLabel value="file" control={<Radio />} label="Upload File" />
//               </RadioGroup>
//             </FormControl>
//           </Box>

//           {linkType === "url" ? (
//             <TextField
//               margin="dense"
//               fullWidth
//               label="Link URL"
//               value={formData.link}
//               error={!!formErrors.link}
//               helperText={formErrors.link}
//               onChange={(e) => setFormData({ ...formData, link: e.target.value })}
//             />
//           ) : (
//             <Box mt={1}>
//               <Button variant="outlined" component="label" fullWidth>
//                 Choose file
//                 <input
//                   type="file"
//                   hidden
//                   onChange={(e) => {
//                     const f = e.target.files[0];
//                     setFile(f);
//                     setFormErrors({ ...formErrors, link: undefined });
//                   }}
//                 />
//               </Button>
//               {file && (
//                 <Typography variant="body2" sx={{ mt: 1 }}>
//                   Selected file: {file.name}
//                 </Typography>
//               )}
//               {formErrors.link && (
//                 <Typography variant="caption" color="error">
//                   {formErrors.link}
//                 </Typography>
//               )}
//             </Box>
//           )}

//           <TextField
//             margin="dense"
//             fullWidth
//             type="date"
//             label="Date of Issue"
//             InputLabelProps={{ shrink: true }}
//             value={formData.date_of_issue}
//             error={!!formErrors.date_of_issue}
//             helperText={formErrors.date_of_issue}
//             onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
//           />

//           <TextField
//             margin="dense"
//             fullWidth
//             type="date"
//             label="Date of Expiry"
//             InputLabelProps={{ shrink: true }}
//             value={formData.date_of_expiry}
//             error={!!formErrors.date_of_expiry}
//             helperText={formErrors.date_of_expiry}
//             onChange={(e) => setFormData({ ...formData, date_of_expiry: e.target.value })}
//           />

//           <Box mt={1}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.is_active}
//                   onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
//                 />
//               }
//               label="Active"
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
//           <Button variant="contained" color="primary" onClick={handleFormSubmit}>
//             {isEditMode ? "Update" : "Add"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this news item?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button variant="contained" color="error" onClick={handleDelete}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  IconButton,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Switch,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import TableComponent from "../../Components/TableComponent/TableComponent";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { API_BASE_URL } from "../../config";
import api from "../../api/axiosInterceptor";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

export const AdminNewsComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  // Added language field to formData
  const [formData, setFormData] = useState({
    subject: "",
    link: "",
    date_of_issue: "",
    date_of_expiry: "",
    is_active: true,
    langage: "", // Added language field
  });

  const [linkType, setLinkType] = useState("url");
  const [file, setFile] = useState(null);

  const [formErrors, setFormErrors] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteNews, setDeleteNews] = useState(null);

  // NEW: Control for showing all news vs filtered news
  const [showAllNews, setShowAllNews] = useState(false);

  // Language options
  const languageOptions = [
    { value: "en", label: "English" },
    { value: "kn", label: "Kannada" },
  ];

  const location = useLocation();
  const navigate = useNavigate();

  // Update showAllNews from query param on mount and location change
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const all = params.get("all");
    setShowAllNews(all === "true");
  }, [location.search]);

  // Fetch news with optional query param based on showAllNews
  const fetchNews = () => {
    setLoading(true);
    const url = `${API_BASE_URL}/home-notification/news/`;
    const params = showAllNews ? { all: "true" } : {};
    axios
      .get(url, { params })
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          viewDetails: item.link,
          date_of_issue: item.date_of_issue,
          date_of_expiry: item.date_of_expiry,
          is_active: item.is_active,
          langage: item.langage, // Added language field
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage("Failed to load news.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    // Whenever showAllNews changes, update the URL query param and fetch data
    const params = new URLSearchParams(location.search);
    if (showAllNews) {
      params.set("all", "true");
    } else {
      params.delete("all");
    }
    // Update URL without reload
    navigate({ search: params.toString() }, { replace: true });
    fetchNews();
  }, [showAllNews]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddNews = () => {
    setIsEditMode(false);
    setFormData({
      subject: "",
      link: "",
      date_of_issue: "",
      date_of_expiry: "",
      is_active: true,
      langage: "", // Reset language
    });
    setLinkType("url");
    setFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (news) => {
    setIsEditMode(true);
    setSelectedNews(news);
    setFormData({
      subject: news.subject || "",
      link: news.viewDetails || "",
      date_of_issue: news.date_of_issue || "",
      date_of_expiry: news.date_of_expiry || "",
      is_active: news.is_active ?? true,
      langage: news.langage || "", // Added language field
    });
    setLinkType("url");
    setFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (news) => {
    setDeleteNews(news);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(`/home-notification/news/${deleteNews.id}/`)
      .then(() => {
        setSnackbarMessage("News deleted successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        fetchNews();
      })
      .catch(() => {
        setSnackbarMessage("Failed to delete news.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteNews(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = "Subject is required";
    if (!formData.date_of_issue) errors.date_of_issue = "Issue date is required";
    if (!formData.date_of_expiry) errors.date_of_expiry = "Expiry date is required";
    if (formData.date_of_issue && formData.date_of_expiry) {
      if (new Date(formData.date_of_expiry) < new Date(formData.date_of_issue))
        errors.date_of_expiry = "Expiry date cannot be before issue date";
    }
    if (!formData.langage) errors.langage = "Language is required"; // Added language validation

    if (linkType === "url") {
      if (!formData.link?.trim()) errors.link = "Link is required";
      else if (!/^https?:\/\/.+\..+/.test(formData.link)) errors.link = "Invalid link format";
    } else {
      if (!file) errors.link = "File is required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const formDataToSend = new FormData();
    formDataToSend.append("subject", formData.subject);
    formDataToSend.append("date_of_issue", formData.date_of_issue);
    formDataToSend.append("date_of_expiry", formData.date_of_expiry);
    formDataToSend.append("is_active", formData.is_active);
    formDataToSend.append("langage", formData.langage); // Added language field

    if (linkType === "url") {
      formDataToSend.append("link", formData.link);
    } else if (file) {
      formDataToSend.append("link", file);
    }

    const url = isEditMode
      ? `/home-notification/news/${selectedNews.id}/`
      : `/home-notification/news/`;
    const method = isEditMode ? "patch" : "post";

    try {
      await api[method](url, formDataToSend, {
        // credentials: 'include', 
        headers: { "Content-Type": "multipart/form-data" },
      });
      setSnackbarMessage(isEditMode ? "News updated successfully." : "News added successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      fetchNews();
    } catch {
      setSnackbarMessage(isEditMode ? "Failed to update news." : "Failed to add news.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setOpenFormDialog(false);
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  const columns = [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    { id: "subject", field: "subject", headerName: "Subject", width: 220 },
    { 
      id: "langage", 
      field: "langage", 
      headerName: "Language", 
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.value === "en" ? "English" : params.value === "kn" ? "Kannada" : params.value || "N/A"}
        </Typography>
      ),
    },
    { id: "date_of_issue", field: "date_of_issue", headerName: "Issue Date", width: 130 },
    { id: "date_of_expiry", field: "date_of_expiry", headerName: "Expiry Date", width: 130 },
    {
      id: "is_active",
      field: "is_active",
      headerName: "Active",
      width: 80,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      id: "viewDetails",
      field: "viewDetails",
      headerName: "View Details",
      width: 140,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          View Details
        </a>
      ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="rgba(195,234,203,0.1)"
        p={2}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
          News
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Typography>Show All News</Typography>
          <Switch
            checked={showAllNews}
            onChange={() => setShowAllNews(!showAllNews)}
            inputProps={{ "aria-label": "show all news toggle" }}
          />
          <Button variant="contained" color="primary" onClick={handleAddNews}>
            Add News
          </Button>
        </Box>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ "& .MuiDataGrid-columnHeaders": { backgroundColor: "#1976d2", color: "#fff", fontWeight: "bold" } }}
      />

      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? "Edit News" : "Add News"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            fullWidth
            label="Subject"
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
          />

          {/* Language Dropdown */}
          <FormControl fullWidth margin="dense" error={!!formErrors.langage}>
            <InputLabel>Language</InputLabel>
            <Select
              value={formData.langage}
              label="Language"
              onChange={(e) => setFormData({ ...formData, langage: e.target.value })}
            >
              {languageOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box mt={2}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Link Type</FormLabel>
              <RadioGroup
                row
                value={linkType}
                onChange={(e) => {
                  setLinkType(e.target.value);
                  setFormData({ ...formData, link: "" });
                  setFile(null);
                  setFormErrors({ ...formErrors, link: undefined });
                }}
              >
                <FormControlLabel value="url" control={<Radio />} label="URL" />
                <FormControlLabel value="file" control={<Radio />} label="Upload File" />
              </RadioGroup>
            </FormControl>
          </Box>

          {linkType === "url" ? (
            <TextField
              margin="dense"
              fullWidth
              label="Link URL"
              value={formData.link}
              error={!!formErrors.link}
              helperText={formErrors.link}
              onChange={(e) => setFormData({ ...formData, link: e.target.value })}
            />
          ) : (
            <Box mt={1}>
              <Button variant="outlined" component="label" fullWidth>
                Choose file
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    const f = e.target.files[0];
                    setFile(f);
                    setFormErrors({ ...formErrors, link: undefined });
                  }}
                />
              </Button>
              {file && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Selected file: {file.name}
                </Typography>
              )}
              {formErrors.link && (
                <Typography variant="caption" color="error">
                  {formErrors.link}
                </Typography>
              )}
            </Box>
          )}

          <TextField
            margin="dense"
            fullWidth
            type="date"
            label="Date of Issue"
            InputLabelProps={{ shrink: true }}
            value={formData.date_of_issue}
            error={!!formErrors.date_of_issue}
            helperText={formErrors.date_of_issue}
            onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
          />

          <TextField
            margin="dense"
            fullWidth
            type="date"
            label="Date of Expiry"
            InputLabelProps={{ shrink: true }}
            value={formData.date_of_expiry}
            error={!!formErrors.date_of_expiry}
            helperText={formErrors.date_of_expiry}
            onChange={(e) => setFormData({ ...formData, date_of_expiry: e.target.value })}
          />

          <Box mt={1}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_active}
                  onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                />
              }
              label="Active"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleFormSubmit}>
            {isEditMode ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this news item?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
